import script from "./RegisterAdvertisement.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterAdvertisement.vue?vue&type=script&setup=true&lang=js"

import "./RegisterAdvertisement.vue?vue&type=style&index=0&id=a5845714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5845714"]])

export default __exports__